import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";
import SellMyRV from "@/pages/SellMyRV";

export const Route = createFileRoute("/sell-your-rv")({
  head: () => pageHead({
    title: 'Sell Your RV',
    description: 'Sell or consign your RV with Rex & Sons RVs in Castle Hayne, NC — fast appraisals, fair offers and hassle-free paperwork.',
    path: '/sell-your-rv',
  }),
  component: SellMyRV,
});
